
export type ApiErrorBody = {
  error?: string;
  message?: string;

  code?: string;

  error_code?: string;
  errors?: Record<string, string[] | string>;
};

function isAxiosNoiseMessage(msg: string): boolean {
  const t = msg.trim();
  if (!t) return true;
  if (/^Request failed with status code \d+$/i.test(t)) return true;
  return t === 'Network Error';
}

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err == null || err === undefined) return fallback;
  if (typeof err === 'string' && err.trim()) return err;

  if (typeof err !== 'object') return fallback;

  const e = err as {
    message?: string;
    response?: { data?: unknown };
  };

  const data = e.response?.data;
  if (data !== undefined && data !== null) {
    if (typeof data === 'string' && data.trim()) return data;
    if (typeof data === 'object') {
      const d = data as ApiErrorBody;
      if (typeof d.message === 'string' && d.message.trim()) return d.message.trim();
      if (typeof d.error === 'string' && d.error.trim()) return d.error.trim();
      if (d.errors && typeof d.errors === 'object') {
        for (const val of Object.values(d.errors)) {
          if (Array.isArray(val) && val.length > 0 && typeof val[0] === 'string') return val[0];
          if (typeof val === 'string' && val.trim()) return val.trim();
        }
      }
    }
  }

  const msg = e.message;
  if (typeof msg === 'string' && msg.trim() && !isAxiosNoiseMessage(msg)) {
    return msg.trim();
  }

  return fallback;
}
